enum LAYOUT_TYPES {
    VERTICAL = "vertical",
    HORIZONTAL = "horizontal"    
  }
  
  enum LAYOUT_MODE_TYPES {
    LIGHTMODE = "light",
    DARKMODE = "dark",
  }
  
  enum LAYOUT_WIDTH_TYPES {
    FLUID = "fluid",
    BOXED = "boxed",
  }

  enum LAYOUT_POSITION_TYPES {
    FIXED = "fixed",
    SCROLLABLE = "scrollable"
  }

  enum LAYOUT_TOPBAR_THEME_TYPES {
    LIGHT = "light",
    DARK = "dark"
  }

  enum LEFT_SIDEBAR_SIZE_TYPES {
    DEFAULT = "lg",
    COMPACT = "md",
    SMALLICON = "sm",
    SMALLHOVER = "sm-hover"
  }
  
  enum LEFT_SIDEBAR_VIEW_TYPES {
    DEFAULT = "default",
    DETACHED = "detached"
  }

  enum LAYOUT_SIDEBAR_TYPES {
    LIGHT = "light",
    DARK = "dark"
  }
  
  export {
    LAYOUT_TYPES,
    LAYOUT_MODE_TYPES,
    LAYOUT_SIDEBAR_TYPES,
    LAYOUT_WIDTH_TYPES,
    LAYOUT_POSITION_TYPES,
    LAYOUT_TOPBAR_THEME_TYPES,
    LEFT_SIDEBAR_SIZE_TYPES,
    LEFT_SIDEBAR_VIEW_TYPES,
  }
  